import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import s from './ButtonMobile.module.scss';

export interface ButtonMobileProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  type?: 'button' | 'submit' | 'reset';
  variant?: 'fill' | 'secondary' | 'ghost';
  color?: 'green' | 'black' | 'red';
  fullWidth?: boolean;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  children?: ReactNode;
}

export const ButtonMobile: FC<ButtonMobileProps> = ({
  type = 'button',
  variant = 'fill',
  color = 'green',
  fullWidth = true,
  iconLeft,
  iconRight,
  children,
  className,
  disabled,
  ...rest
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={classNames(
        s.ButtonMobile,
        s[`variant-${variant}`],
        s[`color-${color}`],
        { [s.fullWidth]: fullWidth },
        className,
      )}
      {...rest}
    >
      {iconLeft}
      {children}
      {iconRight}
    </button>
  );
};
